<template>
  <div class="goumuguanjia">
    <div class="banner">
      <div class="img">
        <!-- <img src="../../assets/xiaoshou.png" /> -->
        <img :src="this.$store.getters.banner[this.$route.path]" />
      </div>
    </div>

    <div class="content">
      <p class="title">购墓管家</p>
      <div class="contentDiv">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="min-height: 100vh;">
          <van-list v-model="loading" :finished="finished" @load="onLoad">
            <template v-for="item in list">
              <div class="gjlist" :key="item.id">
                <div class="img">
                  <van-image width="3rem" height="3.5rem" fit="cover" :src="item.firstPhoto" />
                </div>
                <div class="content" style="padding:0;margin-left:.3rem;width:18rem;">
                  <div class="line1" style="height:.5rem;">
                    {{ item.userName }}
                  </div>
                  <div class="line2" style="margin-top:.5rem;color: #666;">
                    {{ item.introduce }}
                  </div>
                  <div class="line3" style="margin-top:.5rem;">
                    <span v-for="(item2, index2) in item.labels" :key="index2">{{ item2 }}</span>
                  </div>
                </div>
              </div>
            </template>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goumuguanjia',
  components: {},
  data() {
    return {
      list: [],
      isLoading: false,
      loading: false,
      finished: false,
      page: 1,
    }
  },
  methods: {
    getData() {
      var that = this
      this.$queryPage(
        'OweGuider',
        { page: that.page, size: 10 },
        ['id', 'userName', 'firstPhoto', 'introduce', 'labels'],
        function(res) {
          if (res.data.length > 0) {
            res.data.forEach(item => {
              that.list.push(item)
            })
            that.loading = false
            that.page++
          } else {
            that.finished = true
            that.loading = false
            that.isLoading = false
            that.$notify({
              message: '没有更多数据啦~',
              color: '#ad0000',
              background: '#ffe1e1',
            })
          }
        }
      )
    },
    onLoad() {
      let that = this
      setTimeout(() => {
        if (that.isLoading) {
          that.isLoading = false
        }
        this.getData()
      }, 500)
    },
    onRefresh() {
      this.finished = false
      this.loading = true
      this.onLoad()
    },
  },
  created() {
    this.page = 1
    this.list = []
    this.getData()
  },
}
</script>

<style>
.goumuguanjia .gjlist {
  display: flex;
  margin-bottom: 0.5rem;
  border-bottom: 0.02rem #dfdfdf solid;
  padding-bottom: 0.5rem;
}
.goumuguanjia .line3 span {
  display: inline-block;
  padding: 0.027rem 0.10667rem;
  background: #fbf6ef;
  border-radius: 0.05333rem;
  font-size: 0.32rem;
  color: #dea767;
  margin-right: 0.10667rem;
}
.goumuguanjia .banner {
  height: 3.73rem;
}
.goumuguanjia .title {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;

  margin-bottom: 0.53rem;
}
.goumuguanjia .img {
  width: 100%;
  height: 100%;

  position: relative;
  display: inline-block;
}
.goumuguanjia .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}
.goumuguanjia .content {
  padding: 0.67rem 0.4rem;
  background: #fff;
}
.goumuguanjia .contentTxt {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  -o-tab-size: 4;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  /* white-space: pre-wrap;*/
  word-wrap: break-word;
}
.goumuguanjia .contentTxt p {
  margin: 0.5rem 0;
}
</style>
